export const hasNoUnlimitedOptionChoice = (availableOptions: Object[][]): boolean => {
  if (!availableOptions) {
    return false;
  }

  return availableOptions.every(
    options => options.length >= 3 && options.every(option => option.characteristic.value !== 'UNL')
  );
};
